import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { Input } from "stories/forms";
import { useAppContext } from "contexts/AppContext"

const AccountTypeInput = ({label, name="account_type",setFieldValue, onChange,disabled, icon, value, allOption = true}) => {
  const { t } = useTranslation();
  const { enums } = useAppContext()

 //set first time value to first input options
  useEffect(() => {
  if (value === undefined) {
    setFieldValue("account_type", enums?.accounts?.account?.type[0].key)
    }
    }, [enums])


  const getInputOptions = useCallback(() => {
    const inputOptions = enums?.accounts?.account?.type;
    return inputOptions && inputOptions.map(obj => {
      return (
        <option value={obj.key}>{obj.value}</option>
      )
    })
  }, [enums])
  
  return (
    <Input type="select" label={label} name={name} onChange={onChange} value={value} disabled={disabled} icon={icon}>
      {getInputOptions()}
    </Input>
  )
  
  
}


export default AccountTypeInput;